import { BoxProps } from '@mui/material';
import { DataGridPremiumProps } from '@mui/x-data-grid-premium';
import { DataGridType } from './inc-data-grid.utils';
import { ReactNode } from 'react';
import { AnyObjectSchema } from 'yup';
import { FormDrawerProps } from 'components/drawers/form-drawer/form-drawer.component';
import BulkEditDataGrid from './bulk-edit-data-grid/bulk-edit-data-grid.component';
import IncDataGridWrapee from './inc-data-grid-wrapee/inc-data-grid-wrapee.component';
import {
  useExportLocationsPerformanceCSVMutation,
  useExportLocationsTrendsCSVMutation,
  useExportOfferPerformanceCSVMutation,
  useExportOfferTrendsCSVMutation,
} from 'api/reports-service/reports-service';

export type ToolbarProps = {
  columns?: {
    enabled: boolean;
  };
  bulkEdit?: {
    enabled: boolean;
    fields: Record<
      string,
      {
        schema: AnyObjectSchema;
        FormComponent?: ReactNode;
      }
    >;
    onValid: FormDrawerProps['onValid'];
    additionalMenuItems?: ReactNode[];
  };
  export?: {
    query:
      | typeof useExportOfferPerformanceCSVMutation
      | typeof useExportLocationsPerformanceCSVMutation
      | typeof useExportOfferTrendsCSVMutation
      | typeof useExportLocationsTrendsCSVMutation;
    filteredSearchParams: string[];
    fileName: string;
    queryName: string;
    includeColumnsField: boolean;
  };
};

export type IncDataGridProps = {
  'data-testid'?: string;
  resizable?: boolean;
  dataGridType?: DataGridType;
  toolbar?: ToolbarProps;
  BoxProps?: BoxProps;
} & DataGridPremiumProps;

export const IncDataGrid = (props: IncDataGridProps) => {
  if (!!props.toolbar?.bulkEdit?.enabled)
    return <BulkEditDataGrid {...props} />;

  return <IncDataGridWrapee {...props} />;
};

export default IncDataGrid;
